export default {
  login: {
    title: 'Innskráning',
    phoneNumber: 'Símanúmerið þitt',
    number: '464 6464',
    submitPhoneNumber: 'Staðfesta símanúmer',
    submitSmsCode: 'Staðfesta SMS kóða',
    smsCode: 'Sms kóði',
    enterPhoneNumber: 'Vinsamlegast sláðu inn GSM númerið þitt og við sendum þér kóða til að halda áfram.',
    enterCode: 'Vinsamlegast sláðu inn kóðann sem þú fékkst sendan.',
    code: 'Kóði',
    retry: 'Prufa aftur',
    send: 'Áfram',
    continue: 'Áfram',
    usageInfo: 'Til að geta notað appið þurfum við að samtengja GSM númerið þitt við appið.'
      + ' Þetta þarftu bara að gera einu sinni.',
    appDiscount: {
      discountDay: 'Þriðjudagar eru appdagar.',
      message: '30% afsláttur ef pantað er í appinu á hverjum þriðjudegi!',
    },
    errors: {
      phoneNumber: {
        noInput: 'Símanúmer vantar',
        invalidInput: 'Símanúmer er ekki nógu langt',
      },
      smsCode: {
        noInput: 'Sláðu inn SMS kóða',
        invalidInput: 'SMS kóði skal vera fjórir stafir',
      },
    },
  },
  email: {
    successDialog: {
      title: 'Umsókn send',
      message: 'Takk fyrir umsóknina. Við munum hafa samband.',
    },
  },
  navigation: {
    back: 'Til baka',
  },
  footer: {
    menu: 'Matseðlar',
    order: 'Pöntunin þín',
    settings: 'Stillingar',
    login: 'Innskráning',
    distancing: 'Afhending',
  },
  wolt: {
    title: 'Wolt',
    step1title: 'Hvert viltu fá sent? Skráðu heimilisfang og húsnúmer',
    step2title: 'Hvar er gengið inn? Smelltu til að færa pinnann.',
    address: 'Heimilisfang og húsnúmer',
    addressHint: 'Skráðu aðeins heimilisfang og húsnúmer. Annað fer í athugasemd.',
    comment: 'Athugasemd',
    commentHint: 'Hér tekuru fram íbúðarnúmer, hæð, hurð eða hvað sem hjálpar til með staðsetningu.',
    search: 'Leita',
    confirm: 'Staðfesta',
    addressNotFoundTitle: 'Heimilisfang fannst ekki',
    addressNotFoundMessage: 'Athugaðu að skrá aðeins heimilisfang og húsnúmer.',
  },
  menu: {
    title: 'Matseðlar',
    pizzaOffers: 'Pizzu tilboð',
    lastOrderAgain: 'Panta sama og síðast',
    closed: 'Lokað',
    opensAt: 'Opnum klukkan',
    minutes: 'mín',
    pizza: 'Pizzur',
    combo: 'Pizzur og meððí',
    offer: 'Tilboð',
    about: 'Um Sprettinn',
    application: 'Starfsumsókn',
    login: 'Innskráning',
    logout: 'Útskráning',
    en: 'Icelandic',
    is: 'English',
  },
  categories: {
    small: 'Lítil',
    medium: 'Mið',
    large: 'Stór',
    addToCart: 'Setja í körfu',
  },
  product: {
    pizza: 'Pizza',
    base: 'Botn',
    chooseBase: 'Veldu gerð',
    double: 'Tvöfalt magn',
    triple: 'Þrefalt magn',
    addToOrder: 'Bæta við pöntun',
    chooseOptions: 'Velja',
    changeProduct: 'Breyta',
    updateProductInOrder: 'Breyta vöru',
    split: 'Skipta í tvennt',
    notSplit: 'Ekki skipta í tvennt',
    change: 'Velja',
    hideToppings: 'Fela álegg',
    toppings: 'Álegg',
    chooseToppings: 'Veldu Álegg',
    import: 'Sama álegg og á',
    importFrom: 'Veldu pizzu af matseðli',
    noToppingsSelected: 'Ekkert álegg valið',
    size: {
      title: 'Veldu stærð',
    },
    part: {
      0: 'Fyrri',
      1: 'Seinni',
    },
    price: 'Verð:',
  },
  lastOrder: {
    lastOrderAgain: 'Panta aftur',
  },
  order: {
    editInformation: 'Breyta',
    deliveryMethod: {
      title: 'Pöntun verður ',
      waitingTime: 'Biðtími u.þ.b ',
      deliveryETA: 'Áætluð afhending kl:',
    },
    save: 'Vista',
    errors: {
      dialog: {
        name: 'Nafn úttektaraðila vantar',
        ssnFormat: {
          title: 'Sláðu inn nafn og kennitölu úttektaraðila',
          message: 'Rangt form á kennitölu',
        },
        ssn: {
          empty: 'Kennitölu úttektaraðila vantar',
          length: 'Kennitala þarf að vera 10 stafir',
        },
        save: 'Vista',
      },
    },
    isEmpty: 'Þú hefur ekki sett neitt í pöntunina þína. Skoðaðu matseðilinn og bættu við pöntunina.',
  },
  payment: {
    tds: {
      hint: 'Smelltu á “Senda” til að hefja sterka auðkenningu (SCA) á greiðslukortinu.',
      submit: 'Senda',
      cancel: 'Hætta við',
    },
    valitorPage: {
      hint: 'Smelltu á “Senda” til að greiða á greiðslusíðu Valitor.',
      submit: 'Senda',
      cancel: 'Hætta við',
      footer: 'Ef þú villt hætta við eða þegar greiðslu er lokið er óhætt að loka greiðslusíðunni til að koma til baka.',
    },
    teyaPage: {
      hint: 'Smelltu á “Senda” til að greiða á greiðslusíðu Teya.',
      submit: 'Senda',
      cancel: 'Hætta við',
      footer: 'Ef þú villt hætta við eða þegar greiðslu er lokið er óhætt að loka greiðslusíðunni til að koma til baka.',
    },
    invoiceInternal: {
      description: 'Skráðu upplýsingar um greiðsluna',
      customerSsn: 'Viðskiptamannanúmer',
      ssn: 'Kennitala úttektaraðila',
      name: 'Nafn úttektaraðila',
      save: 'Vista upplýsingar',
      edit: 'Breyta upplýsingum',
      customerNotFound: 'Viðskiptamaður fannst ekki',
    },
    phoneNumber: 'Símanúmer',
    validation: {
      phoneNumber: {
        required: 'Það vantar símanúmer',
        tooShort: 'Símanúmer er of stutt',
      },
    },
    aur: {
      paymentPendingTitle: 'Beðið greiðslu',
      paymentPendingMessage: 'Kláraðu að greiða í gegnum Aur appið til að ljúka pöntun.',
    },
    verifoneCheckout: {
      hint: 'Til að greiða fyrir pöntunina tekur nú við greiðslusíða hjá Verifone. Eftir að greiðsla berst mun pöntunin fara í vinnslu hjá okkur. Smelltu á “Áfram” til að greiða á greiðslusíðu Verifone.',
      submit: 'Áfram',
      cancel: 'Hætta við',
      footer: 'Ef þú villt hætta við eða þegar greiðslu er lokið er óhætt að loka greiðslusíðunni til að koma til baka.',
    },
  },
  cart: {
    distancing: 'Snertilágmörkuð afhending',
    deliveryMethod: 'Afhending',
    buyer: 'Kaupandi',
    correctInformation: 'Eru allar upplýsingar réttar?',
    lastOrder: 'Sama og síðast',
    order: 'Pöntunin þín',
    orderSingular: 'Pöntun',
    changeOrder: 'Breyta',
    remove: 'Eyða',
    price: 'kr.',
    saveProduct: 'Vista',
    removeDialogTitle: 'Eyða vöru',
    removeDialogMessage: 'Ertu viss um að þú viljir eyða vöru úr körfu?',
    backToMenu: 'Aftur í matseðil',
    confirmOrder: 'Staðfesta pöntun',
    total: 'Samtals: ',
    cardNumber: 'Kortanr.',
    secondCardNumber: 'Kortanúmer',
    month: 'Mánuður',
    year: 'Ár',
    cvv: 'CVC',
    saveCardNumber: 'Vista kort',
    payOnArrival: 'Greiða þegar þú sækir á Greifann',
    paymentTitle: 'Veldu greiðsluleið',
    finalizeOrder: 'Ganga frá pöntun',
    minimumPrice: 'Lágmarksupphæð fyrir heimsendingu er',
    sideDishes: {
      title: 'Má bjóða þér að',
      message: 'bæta við pöntunina?',
      choose: 'Veldu meðlæti',
      noSelection: 'Ekkert meðlæti valið',
      drinks: 'Drykkir',
      sides: 'Meðlæti',
      childrenDishes: 'Barnaréttir',
    },
    deliveryMethodDialog: {
      title: 'Afhendingarmáti',
      pickup: 'Sækja',
      delivery: 'Fá heimsent',
      waitingTime: 'Biðtími u.þ.b ',
      methodIsClosed: 'Lokað',
      openAt: 'Opnar kl: ',
    },
    credit: {
      useCredit: 'Nota inneign',
      noCredit: 'Þú átt enga inneign til að nota',
    },
    coupon: {
      title: 'Afsláttarkóði',
      valid: 'Staðfestingarkóði virkur!',
      activate: 'Virkja',
      hint: 'Sláðu inn afsláttarkóðann og smelltu svo á VIRKJA',
    },
    confirmAddress: {
      title: 'Rétt heimilisfang?',
      no: 'Nei',
      yes: 'Já',
    },
    chooseAddress: {
      title: 'Veldu heimilisfang',
      new: 'Stofna nýtt',
      newAddress: 'Stofna nýtt heimilisfang',
      cancel: 'Hætta við',
      confirm: 'Velja',
    },
    confirm: {
      title: 'Staðfesta pöntun',
      message: 'Er allt rétt?',
    },
    clear: {
      title: 'Hætta við pöntun',
      message: 'Öllum vörum verður hent úr pöntuninni',
      ok: 'Já',
      cancel: 'Nei',
    },
    paymentMethod: {
      title: 'Greiða fyrir pöntun',
      invoice: {
        description: 'Þessi pöntun verður sett í reikningsviðskipti á viðskiptamann {externalId}.',
      },
    },
  },
  distancing: {
    whatIs: 'Hvað er snertilágmörkuð afhending?',
  },
  summary: {
    title: 'Takk fyrir pöntunina og verði þér að góðu',
    methods: 'Sent/Sótt',
    ready: 'Áætlaður afhendingartími er',
    backToMenu: 'Aftur á forsíðu',
    trackWithWolt: 'Rekja pöntun með Wolt',
    note: 'Skoða kvittun',
  },
  settings: {
    title: 'Stillingar',
    desktopTitle: 'Upplýsingar',
    lastOrder: {
      title: 'Síðasta pöntun',
    },
    userItems: {
      title: 'Mínir réttir',
      noItems: 'Engir réttir hafa verið vistaðir. Næst þegar þú pantar þá getur þú valið að vista réttinn. Þá mun hann birtast í þessum lista sem auðveldar þér að panta hann aftur síðar.',
      dialog: {
        title: 'Staðfesting',
        message: 'Viltu eyða vöru úr mínum réttum?',
      },
    },
    orders: {
      title: 'Mínar pantanir',
      receipt: 'Skoða kvittun',
      name: 'Spretturinn',
      restaurant: 'Veitingahús',
      ready: 'Tilbúið kl:',
      ordered: 'Pantað kl:',
      description: 'Vörulýsing',
      price: 'Verð',
      total: 'Samtals',
      piece: 'stk @',
      empty: '- Ekkert valið -',
      first: '** Fyrri helmingur **',
      second: '** Seinni helmingur **',
      distancing: 'Snertilaus afhending',
      more: 'Sjá fleiri',
      noMore: 'Ekki fleiri pantanir',
      paymentMethodNotFound: 'Greiðslumáti fannst ekki',
      deliveryMethodNotFound: 'Afhendingarmáti fannst ekki',
    },
    addresses: {
      title: 'Heimilisföng',
      add: 'Bæta við heimilisfangi',
      edit: 'Breyta heimilisfangi',
      default: 'Valið heimilisfang',
      setAsDefault: 'Setja sem heimilisfang',
      address: 'Heimilisfang',
      addressError: 'Vinsamlegast sláðu inn heimilisfang',
      notes: 'Hæð eða aðrar upplýsingar',
      postalCode: 'Póstnúmer',
      postalCodeError: 'Vinsamlegast veldu póstnúmer',
      save: 'Vista',
      cancel: 'Hætta við',
      confirmation: 'Staðfesting',
      message: 'Viltu virkilega eyða heimilisfangi?',
    },
    cards: {
      title: 'Vistuð kort',
      addCard: 'Bæta við korti',
      removeCard: 'Eyða korti',
      removeCardConfirm: 'Ertu viss um að þú viljir eyða þessu korti?',
      error: 'Villa',
      cancel: 'Hætta við',
      noRegisteredCards: 'Þú átt engin vistuð kort. Smelltu á takkann niðri til að bæta við korti.',
      expiration: 'Kort gildir til',
      cardNumberRequired: 'Kortanúmer vantar',
      cardNumberInvalid: 'EKki rétt form',
      monthRequired: 'Mánuð vantar',
      monthInvalid: 'Mánuður ekki til',
      yearRequired: 'Ár vantar',
      yearInvalid: 'Ekki rétt form',
      yearHasPassed: 'Kort er útrunnið',
      ccvRequired: 'CCV vantar',
      ccvInvalid: 'Ekki rétt form',
    },
    logout: {
      title: 'Skrá mig út',
      cancelOrder: 'Hætta við pöntun',
      message: 'Ertu viss um að þú viljir skrá þig út?',
    },
    userInformation: {
      title: 'Mínar upplýsingar',
      phone: 'Símanúmer',
      name: 'Fullt nafn',
      ssn: 'Kennitala á reikning',
      ssnMessage: 'Aðeins ef kennitala þarf að koma fram á reikning',
      extra: 'Auka upplýsingar',
      save: 'Vista',
      customer: 'Viðskiptamaður',
    },
    products: {
      title: 'Mínir réttir',
      dialog: {
        title: 'Veldu nafn á rétt',
        send: 'Vista',
        error: 'Nafn vantar',
      },
    },
  },
  notifications: {
    defaultTitle: 'Skilaboð',
    addedToOrder: '{thing} bætt við pöntun',
    updatedInOrder: '{thing} uppfært í pöntun',
  },
  dialog: {
    yes: 'Já',
    no: 'Nei',
    cancel: 'Hætta við',
    save: 'Vista',
    confirm: 'Staðfesta',
    submit: 'Senda',
    forward: 'Áfram',
  },
  form: {
    error: {
      required: 'Þennan reit þarf að fylla út',
      invalidSsn: 'Ógild kennitala',
      invalidPersonSsn: 'Kennitala má ekki vera kennitala fyrirtækis',
      sameAsCustomerSsn: 'Kennitala má ekki vera sú sama og viðskiptamannanúmer',
    },
  },
  api: {
    error: {
      pilotErrorWoltServiceError: {
        title: 'Villa í samskiptum',
        message: 'Vefþjónusta Wolt skilaði villu.',
      },
      pilotErrorInvalidPhoneNumber: {
        title: 'Símanúmer rangt',
        message: 'Kerfið tekur aðeins við íslenskum farsímanúmerum.',
      },
      pilotErrorDeliveryDataMissing: {
        title: 'Pöntun ekki vistuð',
        message: 'Upplýsingar um afhendingu vantar.',
      },
      pilotErrorPaymentGatewayError: {
        title: 'Villa í samskiptum við greiðsluþjónustu',
        message: 'Skilaboð frá greiðsluþjónustu: {error}',
      },
      pilotErrorInvalidVerificationCode: {
        title: 'Staðfestingarkóði rangur',
        message: 'Athugaðu hvort hann sé rétt sleginn inn.',
      },
      pilotErrorCouponExpired: {
        title: 'Afsláttarkóði útrunninn',
        message: 'Kóðinn sem þú gafst upp er ekki virkur.',
      },
      pilotErrorCouponNotFound: {
        title: 'Afsláttarkóði finnst ekki',
        message: 'Athugaðu hvort hann sé rétt sleginn inn.',
      },
      pilotErrorInvalidCardNumber: {
        title: 'Kortanúmer ógilt',
        message: 'Athugaðu hvort þú hafir gefið upp rétt númer.',
      },
      pilotErrorExpiredCard: {
        title: 'Gildistími korts er útrunninn',
        message: 'Prófaðu annað kort eða annan greiðslumáta.',
      },
      pilotErrorInvalidCardLength: {
        title: 'Villa í kortanúmeri',
        message: 'Kortanúmer verður að vera 11 til 19 tölustafir',
      },
      pilotErrorOrderNotSaved: {
        title: 'Villa í samskiptum',
        message: 'Gat ekki vistað pöntun. Mögulegar ástæður gætu verið vandamál með nettengingu.',
      },
      pilotErrorOrderNotValid: {
        title: 'Engin pöntun fannst',
        message: 'Það getur gerst ef vöruúrval breytist.',
      },
      pilotErrorItemNotAllowedForDeliveryMethod: {
        title: 'Við getum ekki afgreitt "{product}"',
        message: 'Þú verður að velja annan afhendingarmáta.',
      },
      pilotErrorDeliveryMethodMinTotalPrice: {
        title: 'Lágmarksupphæð ekki náð',
        message: 'Til að geta valið þennan afhendingarmáta þarf að panta meira.',
      },
      pilotErrorCouponWrongDeliveryMethod: {
        title: 'Afsláttarkóði ekki leyfður',
        message: 'Þessi afsláttarkóði er ekki í boði fyrir þennan afhendingarmöguleika.',
      },
      pilotErrorPaymentDataShouldNotBeSupplied: {
        title: 'Villa - Pöntun ekki móttekin',
        message: 'Appið þarfnast uppfærslu. Til að hægt sé að panta og greiða þarf að uppfæra appið í gegnum App Store eða Google Play. Þú getur líka pantað á vefnum okkar á spretturinn.is. Afsakaðu óþægindin.',
      },
      couponNeedsDesktop: {
        title: 'Afsláttarkóði ekki leyfður',
        message: 'Þessi afsláttarkóði er aðeins leyfður á vefnum.',
      },
      couponNeedsCordova: {
        title: 'Afsláttarkóði ekki leyfður',
        message: 'Þessi afsláttarkóði er aðeins leyfður í appi.',
      },
      notAllowed: {
        title: 'Aðgerð ekki framkvæmd',
        message: 'Notandi hefur ekki tilskilin leyfi.',
      },
      ECONNABORTED: {
        title: 'Samskipti runnu út á tíma',
        message: 'Keyrsla tók óeðlilega langan tíma.',
      },
      bootFailed: {
        title: 'Villa í samskiptum við vefþjónustu',
        message: 'Ekki tókst að sækja nauðsynlegar upplýsingar í vefþjónustu: {error}',
      },
      outDated: {
        title: 'Appið þarfnast uppfærslu',
        message: 'Til að tryggja að allt gangi rétt fyrir sig mælum við með að þú uppfærið appið í gegnum App Store eða Google Play. Þú getur líka pantað á vefnum okkar á spretturinn.is.',
      },
    },
  },
  serviceWorker: {
    event: {
      updated: {
        title: 'Ný útgáfa af vefnum er í boði',
        message: 'Þú þarft aðeins að endurhlaða síðuna til að uppfæra.',
        ok: 'Endurhlaða síðuna',
        cancel: 'Ekki núna',
      },
    },
  },
  date: {
    days: ['Sunnudagur', 'Mánudagur', 'Þriðjudagur', 'Miðvikudagur', 'Fimmtudagur', 'Föstudagur', 'Laugardagur'],
    daysShort: ['Sun', 'Mán', 'Þri', 'Mið', 'Fim', 'Fös', 'Lau'],
    months: ['Janúar', 'Febrúar', 'Mars', 'Apríl', 'Maí', 'Júní', 'Júlí', 'Ágúst', 'September', 'Október', 'Nóvember', 'Desember'],
    monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Maí', 'Jún', 'Júl', 'Ágú', 'Sep', 'Okt', 'Nóv', 'Des'],
  },
};
